<template>
  <div class="vip-detail-group-orders">
    <el-row :gutter="20" class="margin-bottom">
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table
        :data="vipDetailGroupOrdersInfo.orders"
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          prop="orderId"
          :label="$t('vipDetailGroupOrders.orderId')"
          align="center"
          width="180"
        ></el-table-column>
        <el-table-column
          label="商品图片"
          align="center"
          width="120"
        >
          <template #default="{row}">
            <el-image
              style="width: 50px; height: 50px; border-radius: 10px;"
              :src="row.coverPhoto || '/img/noPhoto.jpg'"
              :preview-src-list="[row.coverPhoto]"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('vipDetailGroupOrders.productName')"
          align="center"
          width="250"
        >
          <template #default="{row}">
            【{{row.userCount}}人团】{{row.prodName}}
          </template>
        </el-table-column>
        <el-table-column
          prop="buyerName"
          :label="$t('vipDetailGroupOrders.buyer')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="groupBuyerName"
          :label="$t('vipDetailGroupOrders.groupLeader')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="buyerCount"
          :label="$t('vipDetailGroupOrders.purchaseQuantity')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          :label="$t('vipDetailGroupOrders.groupPeople')"
          align="center"
          width="150"
        >
          <template #default="{row}">
            {{row.groupCount}}/{{row.userCount}}
          </template>
        </el-table-column>
        <el-table-column
          prop="groupPrice"
          :label="$t('vipDetailGroupOrders.groupPrice')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="stateName"
          :label="$t('vipDetailGroupOrders.status')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="rebateAmount"
          :label="$t('vipDetailGroupOrders.rebateAmount')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="openTime"
          :label="$t('vipDetailGroupOrders.groupStartTime')"
          align="center"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('vipDetailGroupOrders.groupTime')"
          align="center"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="endTime"
          :label="$t('vipDetailGroupOrders.deadline')"
          align="center"
          width="160"
        ></el-table-column>
      </el-table>

      <el-pagination
        class="margin-top"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { listProductGroupOrder } from '@/api/user/vipDetailApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'VipDetailGroupOrders',
  data() {
    return {
      vipDetailGroupOrdersInfo: {
        orders: [],
        link: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
  },
  methods: {
    open(data) {
      this.vipDetailGroupOrdersInfo.link = data.tel
      this.loadGroupOrdersData()
    },
    loadGroupOrdersData() {
      if (!this.vipDetailGroupOrdersInfo.link) return
      
      this.loading = true
      const params = {
        link: this.vipDetailGroupOrdersInfo.link,
        shopId: this.shopId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      listProductGroupOrder(params)
        .then(res => {
          this.vipDetailGroupOrdersInfo.orders = res.data
          this.pagination.total = res.records
          this.loading = false
        })
        .catch(err => {
          console.error('获取拼团订单数据失败:', err)
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadGroupOrdersData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadGroupOrdersData()
    }
  }
}
</script>

<style scoped>
.vip-detail-group-orders {
  padding: 20px;
}
.margin-bottom {
  margin-bottom: 20px;
}
.margin-top {
  margin-top: 20px;
}
.text-right {
  text-align: right;
}
</style>